export default __webpack_public_path__ + "static/you-beauty-happy-woman-a8775fbdfe40d701b1d9be67971374e1.jpg";